<template>
    <div class="carousel-item">
        <AssetItem 
            :asset="asset" 
            :animated="false" 
            :context="false" 
            :overflow="true" 
            @select="handleSelect" />
    </div>
</template>

<script>
import ROUTES from '@generio-ai/library-legacy/constants/routes'
import { mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import AssetItem from '@/components/common/asset/AssetItem.vue'

export default {
    name: 'CarouselItem',
    components: {
        AssetItem
    },
    props: {
        asset: {
            type: Object,
            default: null
        }
    },
    methods: {
        ...mapActions('router', [
            'openRoute'
        ]),
        handleSelect(asset) {
            if (this.asset === null) return
            this.openRoute({
                route: ROUTES.APPSUITE.LIBRARY_FLOWS,
                payload: {
                    id: asset.id
                }
            })
        }
    }
}
</script>

<style scoped>
.carousel-item {
    width: 200px;
    height: 200px;
    border-radius: 8px;
    text-decoration: none;
    border: 1px solid rgb(var(--v-theme-lightbase));
    transition: background-color 0.3s ease, border-color 0.3s ease;
}
</style>